export default (): boolean => {
    return typeof window === 'undefined';
};
